
import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form, Input, Select, Checkbox, ColorPicker } from './ot'
import axios from 'axios';
import Item from "antd/es/list/Item";

const language_culture_code = 'zh-tw'
const BaseCanvasEdit_3_1_Form = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {},
    componentAttributesData = [],
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [count, setCount] = useState(0);
    const ComponentMap = {
        SELECT: Select,
        CHECKBOX: Checkbox,
        INPUT: Input,
        COLOR_SELECT: ColorPicker,
    };

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        form.setFieldsValue(newFormValues);
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {

        setTimeout(() => {
            let formValues = null;
            formValues = form.getFieldsValue();
            onFormFinish({
                ...formValues,
            });
        }, 2000);

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
    }, [formReloadCount]);
    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                ComponentMap={ComponentMap}
                                componentAttributesData={componentAttributesData || []}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    ComponentMap,
    componentAttributesData = [],
}) => {
    return (
        <>
            <Row>
                {componentAttributesData &&
                    componentAttributesData?.map((item, item_index) =>
                        <Col
                            span={
                                24
                            }
                        >

                            {
                                (() => {
                                    const {
                                        component_attributes_id,
                                        component_type,
                                        component_attributes_type,
                                        propety_json,
                                        propety_option_json,
                                        component_attributes_classify_structure_type_data,
                                    } = item;

                                    const Component = ComponentMap[component_type];
                                    const label =
                                        component_attributes_classify_structure_type_data?.find(_ => true)
                                            ?.name_language_data?.find(_ => true)?.language_culture_value || "未命名欄位";

                                    const placeholder = propety_json?.placeholder || "請選擇...";
                                    const options = propety_option_json?.data || [];
                                    const fieldName = `field_${component_attributes_id}`;
                                    const value = "";
                                    if (!Component) return null;
                                    return <Form.Item
                                        labelCol={8}
                                        wrapperCol={16}
                                        {...field}
                                        name={[field?.name ?? '', label]}
                                        fieldKey={[field?.fieldKey ?? '', label]}
                                        label={label}
                                        initialValue={initialValues?.name}
                                    >
                                        <Component
                                            value={value}
                                            placeholder={placeholder}
                                            options={options}
                                            allowClear={true}
                                            // onlyValue={true}
                                            name={fieldName}
                                        />
                                    </Form.Item>;
                                })()
                            }
                        </Col>


                    )}
            </Row>
        </>
    );
};

export default BaseCanvasEdit_3_1_Form;
